import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Music } from "lucide-react";

export default function CGU() {
  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <header className="bg-[#FAF9F6]/90 backdrop-blur-md border-b border-[#6B8576]/10 sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-9 h-9 bg-[#6B8576] rounded-2xl flex items-center justify-center">
              <Music className="w-4 h-4 text-white" strokeWidth={1.5} />
            </div>
            <span className="font-semibold text-[#2A3A31]" style={{ fontFamily: 'Outfit' }}>Audio Sur Mesure</span>
          </Link>
          <Link to="/" className="text-sm text-[#6B8576] font-medium hover:underline flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> Retour
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-testid="cgu-page">
        <h1 className="text-3xl font-semibold text-[#2A3A31] mb-8" style={{ fontFamily: 'Outfit' }}>Conditions Générales d'Utilisation</h1>
        
        <div className="prose prose-sm max-w-none space-y-8 text-[#2C3531]" style={{ fontFamily: 'Manrope' }}>
          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>1. Objet</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Audio Sur Mesure est une application web gratuite proposant des exercices pratiques de mieux-être, un outil de cohérence cardiaque, un carnet de crise et des séances audio pré-enregistrées. Elle est éditée par Lynda Bry-Bonnard, hypnothérapeute et praticienne EMDR.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>2. Accès au service</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              L'inscription est gratuite et ouverte à toute personne majeure. L'utilisateur s'engage à fournir des informations exactes lors de son inscription et à ne pas créer de compte au nom d'un tiers sans son consentement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>3. Nature des contenus</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Les exercices, séances audio et contenus proposés sont des outils de mieux-être basés sur la thérapie stratégique et la psychologie sociale. <strong>Ils ne constituent en aucun cas un acte médical, un diagnostic ou un traitement</strong>. Ils ne remplacent pas une consultation médicale ou psychologique.
            </p>
            <p className="leading-relaxed text-[#5C6A61] mt-2">
              En cas de détresse psychologique ou d'urgence, contactez immédiatement le 3114 (numéro national de prévention du suicide), le 15 (SAMU) ou le 112 (urgences européennes).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>4. Propriété intellectuelle</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              L'ensemble des contenus (textes, exercices, séances audio, design) est protégé par le droit de la propriété intellectuelle. L'utilisateur s'engage à ne pas reproduire, distribuer ou partager ces contenus sans autorisation écrite de Lynda Bry-Bonnard.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>5. Données personnelles</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Le traitement des données personnelles est décrit dans notre <Link to="/confidentialite" className="text-[#6B8576] hover:underline">Politique de confidentialité</Link>. En utilisant l'application, vous acceptez ce traitement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>6. Responsabilité de l'utilisateur</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              L'utilisateur s'engage à utiliser l'application de manière responsable et à ne pas tenter de nuire à son fonctionnement. Tout usage abusif pourra entraîner la suspension ou la suppression du compte sans préavis.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>7. Limitation de responsabilité</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Lynda Bry-Bonnard ne saurait être tenue responsable des dommages directs ou indirects liés à l'utilisation de cette application. L'application est fournie "en l'état" et sa disponibilité ne peut être garantie de manière continue.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>8. Modification des CGU</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Les présentes conditions peuvent être modifiées à tout moment. L'utilisateur sera informé de toute modification significative. La poursuite de l'utilisation de l'application vaut acceptation des nouvelles conditions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>9. Droit applicable</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Les présentes CGU sont soumises au droit français. En cas de litige, les parties s'engagent à rechercher une solution amiable avant tout recours judiciaire. À défaut, les tribunaux d'Angoulême seront compétents.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>10. Contact</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Pour toute question concernant ces conditions :<br />
              Lynda Bry-Bonnard — <a href="mailto:brylynda@gmail.com" className="text-[#6B8576] hover:underline">brylynda@gmail.com</a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
